const SPEECH_RECOGNITION_LANG = 'en-US';

const SPEECH_RECOGNITION_ERRORS = {
    NOT_ALLOWED: 'not-allowed',
    SERVICE_NOT_ALLOWED: 'service-not-allowed',
    AUDIO_CAPTURE: 'audio-capture',
    NO_SPEECH: 'no-speech',
    ABORTED: 'aborted'
};

const SILENT_SPEECH_RECOGNITION_ERRORS = [
    SPEECH_RECOGNITION_ERRORS.NO_SPEECH,
    SPEECH_RECOGNITION_ERRORS.ABORTED
];

const MICROPHONE_ACCESS_MESSAGE = 'Allow microphone access in your browser settings to use voice input.';

const DEFAULT_SPEECH_RECOGNITION_ERROR_MESSAGE = 'Voice input is unavailable right now.';

const SPEECH_RECOGNITION_ERROR_MESSAGES = {
    [SPEECH_RECOGNITION_ERRORS.NOT_ALLOWED]: MICROPHONE_ACCESS_MESSAGE,
    [SPEECH_RECOGNITION_ERRORS.SERVICE_NOT_ALLOWED]: MICROPHONE_ACCESS_MESSAGE,
    [SPEECH_RECOGNITION_ERRORS.AUDIO_CAPTURE]: 'No microphone found. Connect one and try again.'
};

function getSpeechRecognitionConstructor() {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}

function isSpeechRecognitionSupported() {
    return Boolean(getSpeechRecognitionConstructor());
}

function isSilentSpeechRecognitionError(errorType) {
    return SILENT_SPEECH_RECOGNITION_ERRORS.includes(errorType);
}

function getSpeechRecognitionErrorMessage(errorType) {
    if (!errorType) {
        return '';
    }

    return SPEECH_RECOGNITION_ERROR_MESSAGES[errorType] || DEFAULT_SPEECH_RECOGNITION_ERROR_MESSAGE;
}

function appendTranscript(text, transcript) {
    const nextTranscript = transcript.trim();

    if (!nextTranscript) {
        return text;
    }

    if (!text) {
        return nextTranscript;
    }

    return /\s$/.test(text) ? `${text}${nextTranscript}` : `${text} ${nextTranscript}`;
}

export {
    SPEECH_RECOGNITION_LANG,
    getSpeechRecognitionConstructor,
    isSpeechRecognitionSupported,
    isSilentSpeechRecognitionError,
    getSpeechRecognitionErrorMessage,
    appendTranscript
};
